// extracted by mini-css-extract-plugin
export default {"PageDonate":"donate_PageDonate__k-Sko","Content":"donate_Content__xh0m+"};